<template>
    <div class="modal fade text-left" id="personal_info_modal_update" tabindex="-1" role="dialog" aria-labelledby="myModalLabel334" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title text-primary" id="myModalLabel334">Personal Information</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body " v-if="userStore.user">
                    <form>
                        <!-- action="{{ route('user_update', $user) }}" -->
                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label for="firstname">FirstName</label>
                                    <input type="text" class="form-control" name="firstname" id="firstname"
                                        placeholder="First Name..." v-model="userStore.user.firstname"/>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label for="middle_name">Middle Name</label>
                                    <input type="text" class="form-control" placeholder="Middle Name" id="middle_name" v-model="userStore.user.middle_name"/>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <div class="controls">
                                        <label for="lastname">LastName</label>
                                        <input type="text" class="form-control" id="lastname" v-model="userStore.user.lastname" placeholder="Last Name"/>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group" style="margin-bottom: 0px !important;">
                                    <label for="dob">Birth Date</label>
                                    <flat-pickr v-model="userStore.user.dob" :config="userStore.config"  class="form-control"></flat-pickr>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <div class="controls">
                                        <label for="address">Address</label>
                                        <input type="text" class="form-control" placeholder="Address" id="address" v-model="userStore.user.address">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <div class="controls">
                                        <label for="city">City</label>
                                        <input type="text" class="form-control" placeholder="City" id="city" v-model="userStore.user.city">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label for="state">State</label>
                                    <v-select
                                        v-if="statestore.states"
                                        placeholder="Select State"
                                        v-model="userStore.user.state_id"
                                        :options="statestore.states"
                                        :reduce="state => state.id"
                                    />
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <div class="controls">
                                        <label for="zipcode">Zipcode</label>
                                        <input type="text" class="form-control" placeholder="Zipcode" id="zipcode" v-model="userStore.user.zipcode" maxlength="5">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label for="email">
                                        Email
                                    </label>
                                    <input type="text" class="form-control" placeholder="email" v-model="userStore.user.email" id="email" readOnly/>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label for="ssn-input">SSN
                                        <span class="ml-1">
                                            <a href="#" type="submit" data-toggle="modal" data-target="#ssn_modal">
                                                <strong> (Click Here To Update SSN)</strong>
                                            </a>
                                        </span>
                                    </label>
                                    <input type="text" class="form-control" placeholder="SSN" :value="mask(userStore.user.ssn, { unmaskedStartDigits: 0, unmaskedEndDigits: 4 } )" id="ssn-input" readOnly>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <div class="controls">
                                        <label for="phone">
                                            <span class="ml-1">
                                                <a href="#" type="submit" data-toggle="modal" data-target="#twoFactorAuthSmsPhoneModal">
                                                    <strong> (Click Here To Update Phone)</strong>
                                                </a>
                                            </span>
                                        </label>
                                        <input type="text" class="form-control" placeholder="phone" v-model="userStore.user.phone" id="phone" readOnly>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                    <hr>
                    <h4 class="text-primary">Proof of Identity Documents</h4>
                    <p class="text-small text-primary">Accepted Format "PNG, JPEG,JPG, OR HEIF"</p>
                    <proof-identity-document></proof-identity-document>
                </div>
                <div class="modal-footer">
                    <div class="col-12 d-flex flex-sm-row flex-column justify-content-center">
                        <button type="button" id="personal-information-btn-update" class="btn btn-primary mr-sm-1 mb-1 mb-sm-0" @click="updatedAccount">Save</button>
                        <button type="button" data-dismiss="modal" class="btn btn-outline-primary">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {ref} from 'vue'
import { useUserStore } from '../../../../stores/UserStore.js'
import { useStateStore } from '../../../../stores/StateStore.js'
import { useLocalizationStore } from '../../../../stores/LocalizationStore.js'
import ProofIdentityDocument from './ProofIdentityDocument.vue'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import { mask } from '../../../../utilities/_helpers'
import vSelect from 'vue-select'

export default{
    name:'PersonalInfoModal',
    components:{
        ProofIdentityDocument,
        vSelect,
        flatPickr
    },
    setup() {
        return {
            userStore:useUserStore(),
            statestore:useStateStore(),
            localizationStore: useLocalizationStore(),
            mask: mask
        }
    },
    data(){
        return{
            config: {
                wrap: true,
                altFormat: 'j-m-Y',
                altInput: true,
                dateFormat: 'm-d-Y',
            }
        }
    },
    watch: {
    },
    methods:{
        updatedAccount(){
            let $this = this;
            const params = {
                'user' : this.userStore.user.id
            }
            const route = this.$router.resolve(
                {
                    name: 'account-update',
                    params: params
                }
            );
            const data = {
                firstname : this.userStore.user.firstname,
                lastname : this.userStore.user.lastname,
                middle_name : this.userStore.user.middle_name,
                dob : this.userStore.user.dob,
                address : this.userStore.user.address,
                city : this.userStore.user.city,
                state_id : this.userStore.user.state_id,
                zipcode : this.userStore.user.zipcode,
            }
            axios.put(
                route.href,
                data
            ).then(function(response) {
                if(response.data.error == true) {
                    toastr.error(response.data.message, 'Error!');
                    return;
                }
                toastr.success(response.data.message,'success');
                return;
            }).catch(function(error) {
                toastr.error(error.response.data.response_msg, 'Error!');
            });
        }
    }
}
</script>
